import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import Pagination from 'react-js-pagination'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

import ModalCreate from '../components/Usuarios/ModalCreate'
import ModalDelete from '../components/Usuarios/ModalDelete'
import ModalFilter from '../components/Usuarios/ModalFilter'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList';

import {
    getUsuarios,
	toggleSelectItem,
	toggleSelectAllItems,
	filterUsuarios,
	setOrderBy,
	displayModalCreate,
	showHideModalDelete,
	deleteUsuarios,
    changeRecordsToShow,
    showHideModalFilter,
} from '../actions/usuarios'

export const tableCols = [
    { id: 1, caption: 'Nombre de usuario', value: 'username', type: 'string', format: '', width: '20%', LinkToEdit: true },
    { id: 2, caption: 'Nombre Completo', value: 'fullname', type: 'string', format: '', width: '30%' },
    { id: 3, caption: 'Email', value: 'email', type: 'string', format: '', width: '30%' },
    { id: 4, caption: 'Super usuario', value: 'es_superusuario', type: 'bool', format: '', width: '10%' },
    { id: 5, caption: 'LDAP', value: 'ldap', type: 'bool', format: '', width: '10%' },
    { id: 6, caption: 'Estado', value: 'esta_activo', type: 'bool', format: '', width: '10%' },
]

export function findvalues(c, x) {
	let value = x.getIn(c.value.split('.'))
	return value
}

class Usuarios extends Component {
    componentWillMount() {
        this.props.getUsuarios(1)
    }

	render() {
        const { usuarios, orderBy, page, totalRecords, showRecords } = this.props

        const boxActions = [
            // <BoxButton key="ba[0]" name="plus-circle" onClick={ e => this.props.displayModalCreate(true, 'Creación de usuarios', 'create') } title="Nuevo usuario"/>,
            <BoxButton key="ba[1]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Usuarios seleccionados?`, () => this.props.deleteUsuarios()) } disabled={ usuarios.filter(x => x.get('selected')).count() === 0 } danger title="Eliminar parámetro" />,
            <BoxButton key="ba[2]" name="filter" onClick={ e => this.props.showHideModalFilter(true) } title="Filtro"/>,
        ]

        const pagination = <Pagination
            activePage={ page }
            itemsCountPerPage={ showRecords }
            totalItemsCount={ totalRecords }
            pageRangeDisplayed={ 10 }
            onChange={ (pg) => this.props.getUsuarios(pg)  }
            firstPageText={ <FontAwesome name="angle-double-left" /> }
            prevPageText={ <FontAwesome name="angle-left" /> }
            nextPageText={ <FontAwesome name="angle-right" /> }
            lastPageText={ <FontAwesome name="angle-double-right" /> }
        />

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Usuarios del sistema" stretch>
                        <ButtonStrip 
                            actions={ boxActions }
                            totalRecords={ totalRecords }
                            showRecords={ showRecords }
                            changeRecordsToShow={ (records) => this.props.changeRecordsToShow(records) }
                            pagination={ pagination }
                        />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-usuarios">
                                <thead>
                                    <tr>
                                        <th width="20px">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllItems(e.target.checked) } checked={ usuarios.filter(x => x.get('selected')).count() > 0 && usuarios.filter(x => x.get('selected') && x.get('visible')).count() >= usuarios.filter(x => x.get('visible')).count() } />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}` }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        usuarios.filter(x => x.get('visible')).count() > 0 ? usuarios.filter(x => x.get('visible')).map(x => {
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectItem(x.get('id'), e.target.checked) } checked={ x.get('selected') } />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findvalues(c, x)
                                                            if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } className='LinkToEdit' style={ style } onClick={ e => this.props.displayModalCreate(true, 'Modificación de usuarios', 'edit', x.get('id')) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
				<ModalCreate />
                <ModalDelete />
                <ModalFilter />
                <ModalSelectorFromList />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        usuarios: state.usuarios.get('usuarios'),
        orderBy: state.usuarios.get('orderBy'),
        totalRecords: state.usuarios.get('totalRecords'),
        showRecords: state.usuarios.get('showRecords'),
        page: state.usuarios.get('page'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getUsuarios: (page) => dispatch(getUsuarios(page)),
		toggleSelectItem: (id, checked) => dispatch(toggleSelectItem(id, checked)),
		toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
		filterUsuarios: (term) => dispatch(filterUsuarios(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
		displayModalCreate: (show, title, mode, id) => dispatch(displayModalCreate(show, title, mode, id)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
		deleteUsuarios: () => dispatch(deleteUsuarios()),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        showHideModalFilter: (state) => dispatch(showHideModalFilter(state)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios)


// WEBPACK FOOTER //
// ./src/containers/Usuarios.jsx